export const data = [
  {
    menu: "About",
    image: require("../assets/images/sidemenu/about.png"),
    alt: "about",
    label: "About",
  },
  {
    menu: "Work",
    image: require("../assets/images/sidemenu/work.png"),
    alt: "work",
    label: "Work Experience",
  },
  {
    menu: "Skills",
    image: require("../assets/images/sidemenu/skills.png"),
    alt: "skills",
    label: "Skills",
  },
  {
    menu: "Portfolio",
    image: require("../assets/images/sidemenu/portfolio.png"),
    alt: "portfolio",
    label: "Portfolio",
  },
  {
    menu: "Education",
    image: require("../assets/images/sidemenu/education.png"),
    alt: "education",
    label: "Education Timeline",
  },
  {
    menu: "Contact",
    image: require("../assets/images/sidemenu/contact.png"),
    alt: "contact",
    label: "Contact",
  },
  
];
